// src/status.js
export const STATUS_BY_CODE = {
  0: { bg: '#FFFFFF', label: 'UNASSIGNED' },
  1: { bg: '#C757FF', label: 'SOLD' },
  2: { bg: '#FFD966', label: 'RENTED OUT' },
  3: { bg: '#69e7a2ff', label: 'IN STOCK - CALGARY' },
  4: { bg: '#92D050', label: 'IN TRANSIT TO CALGARY' },
  5: { bg: '#92D050', label: 'IN TRANSIT TO CUSTOMER' },
  6: { bg: '#FF0000', label: 'ALERT' },
  7: { bg: '#4183e6ff', label: 'TO ORDER' },
  8: { bg: '#FFCCFF', label: 'ON ORDER' },
  9: { bg: '#00B050', label: 'STOCK & PDI - IN CALGARY' },
  10:{ bg: '#ce951bff', label: 'DEMO' }, 
  11:{ bg: '#1b54ceff', label: 'CHASSIS ALLOCATION SLOT' },
  12:{ bg: '#e2df1d94', label: 'READY AT FACTORY' },
  13: { bg: '#FF0000', label: 'IN TRANSIT - BROKE DOWN' },
};

const normalize = (s) => String(s ?? '').trim().toLowerCase();

const LABEL_TO_CODE = Object.fromEntries(
  Object.entries(STATUS_BY_CODE).map(([code, v]) => [normalize(v.label), Number(code)])
);

export function parseBool(v) {
  const s = normalize(v);
  return v === true || v === 1 || v === '1' || s === 'true' || s === 'yes' || s === 'y';
}

export function getStatusMeta(record) {
  const alert = parseBool(record?.alert ?? record?.['alert.1']);
  if (alert) return { bg: '#FF0000', label: 'ALERT' };

  const raw = record?.unit_status ?? record?.['unit_status.1'] ?? '';

  const asNum = Number(raw);
  if (!Number.isNaN(asNum) && raw !== '' && raw !== null && raw !== undefined) {
    return STATUS_BY_CODE[asNum] || { bg: '#dbeafe', label: String(raw) };
  }

  const code = LABEL_TO_CODE[normalize(raw)];
  if (code !== undefined) return STATUS_BY_CODE[code];

  const cc = Number(record?.color_code);
  if (!Number.isNaN(cc) && record?.color_code !== '' && record?.color_code !== null && record?.color_code !== undefined) {
    return STATUS_BY_CODE[cc] || { bg: '#dbeafe', label: 'Unknown' };
  }

  return { bg: '#dbeafe', label: raw ? String(raw) : 'Unknown' };
}
